import { render, staticRenderFns } from "./AddNewLearningUnit.vue?vue&type=template&id=d5a7f016&scoped=true&"
import script from "./AddNewLearningUnit.vue?vue&type=script&lang=js&"
export * from "./AddNewLearningUnit.vue?vue&type=script&lang=js&"
import style0 from "./AddNewLearningUnit.vue?vue&type=style&index=0&id=d5a7f016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a7f016",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VForm,VRow,VSwitch,VTextField})
